/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProductStatus = {
    RESERVED: 'RESERVED',
    RECEIVED: 'RECEIVED',
    PAID_CANCELLED: 'PAID_CANCELLED',
    CANCELLED: 'CANCELLED',
    REFUNDED: 'REFUNDED',
    CART: 'CART',
    CART_CANCELLED: 'CART_CANCELLED',
    TRANSFER: 'TRANSFER',
    DISCARDED: 'DISCARDED',
    REGISTER: 'REGISTER',
    INVENTORY: 'INVENTORY',
    RESTORATION: 'RESTORATION'
} as const;
export type ProductStatus = typeof ProductStatus[keyof typeof ProductStatus];

